import PaywayChooseModal from '../pages/voting-pages/session/PaywayChooseModal';
import { payWithPaydunya } from '../commons/Paydunya';
import Helpers from '../utils/Helpers';
import {InvoicesService} from "../services/InvoicesService";
import Consts from "../commons/Consts";
import { useTranslation } from 'react-i18next';
import Paystack from '@paystack/inline-js';

export const PaymentInstance = ({ opened, onSuccess, onError, onClose, options }) => {
  const { t } = useTranslation('paymentInstanceComponent');

  const handlePayViaPaydunya = (params) => {
    payWithPaydunya.onError = error => {
      onError && onError(error);
    }
    payWithPaydunya.onFinish = (ref, _token, _status) => {
      if (['CANCELED', 'FAILED'].includes(_status)) {
        InvoicesService.updateInvoiceStatus(payWithPaydunya.token, _status).then(() => {}).catch(err => {});
      }
      else if (_status === 'COMPLETED' || _status === 'PENDING') {
        InvoicesService.checkInvoiceStatus(payWithPaydunya.token)
          .then(response => {
            payWithPaydunya.status = response.status === 'PAID' ? 'COMPLETED' : 'FAILED';
            response.status === 'PAID' && (payWithPaydunya.data = response.customs);
          })
          .catch(() => {
            payWithPaydunya.status = 'RELOAD';
          });
      }
    }
    payWithPaydunya.onClose = () => {
      if (payWithPaydunya.status === 'COMPLETED') {
        Helpers.alert.success(t('Félicitations'))
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            onSuccess && onSuccess(payWithPaydunya.token, payWithPaydunya.data);
          })
      }
      else {
        if (!payWithPaydunya.status) {
          InvoicesService.updateInvoiceStatus(payWithPaydunya.token, 'CANCELED')
            .then(r => {
              if (r.finalstate === 'COMPLETED') {
                payWithPaydunya.data = r.customs;
              }
              payWithPaydunya.status = r.finalstate;
              payWithPaydunya.onClose();
            })
            .catch(err => {});
        }
        else if (['FAILED', 'PENDING', 'CANCELED'].includes(payWithPaydunya.status)) {
          Helpers.alert.error(t('Paiement échoué'));
          onError && onError();
        }
      }
    }
    payWithPaydunya.launch({
      setupURL: `${Consts.baseapi}/invoices/initialize`,
      ...options,
      setupData: {...options.setupData, ...params},
      params
    })
  }

  const handlePayViaPaystack = (params) => {
    const endAction = (err) => {
      err && onError && onError(err);
    };

    InvoicesService.initialize({
      ...options.setupData,
      ...params,
      is_paystack: 1,
      way: 'card-paystack'
    })
      .then(response => {
        const popup = new Paystack();
        popup.newTransaction({
          key: response.paystack_public_key,
          amount: response.amount * 100,
          email: params.email,
          firstName: params.fullName,
          currency: 'XOF',
          reference: response.token,
          channels: ['card'],
          onSuccess: () => {
            InvoicesService.checkInvoiceStatus(response.token)
              .then(status => {
                if (status.status === 'PAID') {
                  onSuccess && onSuccess(response.token, status.customs);
                } else {
                  Helpers.alert.error(t('Paiement échoué'));
                  endAction();
                }
              })
              .catch(() => {
                Helpers.alert.error(t('Paiement échoué'));
                endAction();
              });
          },
          onError: () => {
            Helpers.alert.error(t('Paiement échoué'));
            InvoicesService.updateInvoiceStatus(response.token, 'FAILED').catch(() => {});
            endAction();
          },
          onCancel: () => {
            InvoicesService.updateInvoiceStatus(response.token, 'CANCELED').catch(() => {});
            endAction();
          }
        });
      })
      .catch(err => {
        Helpers.alert.error(err.message || t('Paiement échoué'));
        endAction(err);
      });
  };

  return (
    <>
      <PaywayChooseModal
        opened={
          opened
              ? { getLinkUrl: options.setupURL, getLinkData: options.setupData }
              : null
        }
        onAskClose={values => {
          values?.by === 'others' && handlePayViaPaydunya(values?.params);
          values?.by === 'card-pay' && handlePayViaPaystack(values?.params);
          onClose && onClose(values?.token ? values : null);
        }}
        mandatoryInfos={options.mandatoryInfos}
        legacy={false}
      />
    </>
  )
}
